
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_45282","data-name":"Group 45282","xmlns":"http://www.w3.org/2000/svg","width":"20.002","height":"20.002"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-onboarding-add-on"}},[_c('rect',{attrs:{"id":"Rectangle_15171","data-name":"Rectangle 15171","width":"20.002","height":"20.002","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_45276","data-name":"Group 45276","clip-path":"url(#clip-path-onboarding-add-on)"}},[_c('path',{attrs:{"id":"Path_32389","data-name":"Path 32389","d":"M18.438 5.368h-.62V3.416a1.567 1.567 0 00-1.564-1.557H12.7a1.563 1.563 0 00-1.562 1.562v1.948h-2.27V3.418A1.565 1.565 0 007.3 1.859H3.749a1.564 1.564 0 00-1.563 1.562v1.948H1.6A1.53 1.53 0 000 6.917v9.691a1.564 1.564 0 001.551 1.536h16.888A1.568 1.568 0 0020 16.595V6.906a1.566 1.566 0 00-1.563-1.538m-5.9-1.947a.166.166 0 01.165-.166h3.556a.166.166 0 01.166.164v1.949h-3.89zm-8.951 0a.166.166 0 01.166-.166H7.3a.166.166 0 01.166.164v1.949H3.583zM18.6 16.583a.184.184 0 01-.181.164H1.566c-.126-.006-.169-.073-.17-.153V6.928a.171.171 0 01.181-.164h16.862a.17.17 0 01.117.047.16.16 0 01.049.105z","fill":"#262626"}})])])
          )
        }
      }
    